import { v4 as uuidv4 } from 'uuid'

export const SWR_REQUEST_ID_HEADER = 'x-trust-swr-request-id'

export const getSwrRequestIdHeader = (
  headers?: Record<string, string | undefined>,
): Record<typeof SWR_REQUEST_ID_HEADER, string> => {
  const requestId = headers?.[SWR_REQUEST_ID_HEADER]
  return {
    [SWR_REQUEST_ID_HEADER]: requestId || uuidv4(),
  }
}
